import { configureStore } from '@reduxjs/toolkit';

import assetTreeReducer, { FEATURE_SLICE_NAME as assetTreeSliceName } from '@/configuration/assetTree/assetTreeSlice';
import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import { dialogApi } from '@/services/dialogsApi';
import { vehicleDiagnosticsApi } from '@/services/vehicleDiagnosticsApi';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        [dialogApi.reducerPath]: dialogApi.reducer,
        [vehicleDiagnosticsApi.reducerPath]: vehicleDiagnosticsApi.reducer,
        [assetTreeSliceName]: assetTreeReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(vehicleDiagnosticsApi.middleware, dialogApi.middleware),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
